import { triggerAnalytics } from './analytics-utils';

export default class PageLoadEvents {

  // 7.39.3 Path to Pro My Dashboard
  myDashboardPage = () => {
    triggerAnalytics('pathToProNetwork.my-dashboard.page-load');
  };

  // 7.39.10 Job Applicants page
  jobApplicantsPage = () => {
    triggerAnalytics('pathToProNetwork.job-applicants.page-load');
  };

  // 1.1 Path to Pro Page View
  landingPage = () => {
    triggerAnalytics('pathToProNetwork.landing.page-load');
  };

  // 1.3 Find Candidates Page
  candidateSearchPage = () => {
    triggerAnalytics('pathToProNetwork.candidate-search.page-load');
  };

  // 1.5 Candidate Page
  candidatePage = (templates) => {
    triggerAnalytics('pathToProNetwork.candidate-search.candidate-page', {
      templates
    });
  };

  // 1.6 Job Postings Page
  jobPostingsPage = () => {
    triggerAnalytics('pathToProNetwork.dashboard.job-postings-page');
  };

  // 1.6.1.1 Create New Job Posting
  createNewJobPosting = () => {
    triggerAnalytics('pathToProNetwork.my-dashboard.job-postings.create-new.overlay');
  };

  // 1.7 Job Posting Detail Page (Job Applicants Page)
  jobPostingDetailsPage = () => {
    triggerAnalytics('pathToProNetwork.dashboard.job-posting-details');
  };

  // 1.8 Left Nav Link
  landingPageReferFromMyAccountSideBar = () => {
    triggerAnalytics('pathToProNetwork.landing.nav-link-click');
  };

  // 2.1 My Account Path to Pro Pod Click
  landingPageReferFromMyAccount = () => {
    triggerAnalytics('pathToProNetwork.landing.pod-click');
  };

  // PTPN2279 - Job Postings Templates Page Load
  jobPostingsTemplatesPage = () => {
    triggerAnalytics('pathToProNetwork.page-load', {
      breadCrumbLabels: ['path to pro network', 'job postings', 'job templates']
    });
  }
}
